var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{domProps:{"innerHTML":_vm._s(_vm.visionx)}},[_vm._v(_vm._s(_vm.$t(("" + _vm.visionx))))])}
var staticRenderFns = []

export { render, staticRenderFns }